import { render, staticRenderFns } from "./CookieSettingsButton.vue?vue&type=template&id=c010d50a&scoped=true"
import script from "./CookieSettingsButton.vue?vue&type=script&lang=js"
export * from "./CookieSettingsButton.vue?vue&type=script&lang=js"
import style0 from "./CookieSettingsButton.vue?vue&type=style&index=0&id=c010d50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c010d50a",
  null
  
)

export default component.exports